module.exports = __webpack_public_path__ + "media/images/emblems/Freienstein-Teufen-blazon-8dadb3094060c2508c856bfcd11315ee.svg";